import { render, staticRenderFns } from "./DashDemandRequests.vue?vue&type=template&id=6615b43d&scoped=true&"
import script from "./DashDemandRequests.vue?vue&type=script&lang=js&"
export * from "./DashDemandRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615b43d",
  null
  
)

export default component.exports